import StateCardView from "components/base/StateCardView";

const SupplierUserInfoView = ({ supplier }) => {
  if (!supplier.user)
    return (
      <StateCardView primary>
        <div className="text-red-600 font-semibold">
          This supplier has no user associated with it. Please create a user for
          this supplier before doing any assessment.
        </div>
      </StateCardView>
    );

  if (!supplier.user.email)
    return (
      <StateCardView primary>
        <div className="text-red-600 font-semibold">
          This supplier user(username: {supplier.user.username}) has no email
          associated with it. Please add email for this user before doing any
          assessment.
        </div>
      </StateCardView>
    );

  return null;
};

export default SupplierUserInfoView;
